/* Admin wrappers — same UI as hotel pages, but pinned to hotel_id from URL param. */
import React from "react";
import { useParams } from "react-router-dom";
import HotelPosPage from "@/pages/HotelPosPage";
import HotelPromotionsPage from "@/pages/HotelPromotionsPage";

export function AdminHotelPosPage() {
    const { id } = useParams();
    return <HotelPosPage overrideHotelId={id} useAdminLayout />;
}

export function AdminHotelPromotionsPage() {
    const { id } = useParams();
    return <HotelPromotionsPage overrideHotelId={id} useAdminLayout />;
}
